<template>
  <div id="mainPage">
    <left-menu />
    <div id="rightMenu">
      <div class="menu-header flex-align">
        <div v-if="$store.getters.curList.length>0" class="cur-list">
          <div
            v-for="(cur, index) in $store.getters.curList"
            :key="index"
            class="cur"
          >
            <div class="cur-name flex-align">
              <img :src="getCountryLogo(cur.curType)">
              <span>{{ cur.curType }}</span>
            </div>
            <div class="amount_box">
              <div class="available-amount">
                {{
                  cur.totalAmount
                    ? parseMoney(cur.totalAmount, cur.curType)
                    : "0.00"
                }}
              </div>
              <div v-if="cur.freezeAmount !== 0" class="wait-amount">
                <span>{{ $t("pages_main_024")
                }}{{ parseMoney(cur.freezeAmount, cur.curType) }}</span>
              </div>
            </div>
          </div>
        </div>
        <a-button
          v-if="$store.getters.curList.length !== 0"
          shape="round"
          type="primary"
          style="font-size: 13px; margin-left: 12px"
          @click="$router.push('/wallet/index')"
        >{{ $t("pages_main_027") }}</a-button>
        <a-tooltip placement="bottom">
          <template #title>
            <div>{{ $t("pages_main_025") }}</div>
            <div>{{ $t("pages_main_026") }}</div>
          </template>
          <!-- <question-circle-filled class="ic-tip" style="color:#BA8438;margin-left: 12px" /> -->
        </a-tooltip>
        <div style="margin-left: auto">
          <div class="flex-align">
            <global-outlined class="ic-global" />
            <language-selector style="color: #000000" />
            <img class="user-header" src="@/assets/images/user-header.png">
            <a-dropdown>
              <a class="merchant-email" @click.prevent>
                <span
                  style="color: #000000; font-weight: 600; font-size: 14px"
                >{{ $t("pages_main_053")
                }}{{ $store.getters.getUserInfo.merchantName }}</span><br>
                {{ $store.getters.getUserInfo.email }}
              </a>
              <template #overlay>
                <a-menu style="background: #fff;height: 150px;">
                  <a-menu-item>
                    <a @click="$router.push('/user/account_materials')">{{
                      $t("pages_router_031")
                    }}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="$router.push('/user/user_manage')">{{
                      $t("pages_router_032")
                    }}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="$router.push('/user/account_security')">{{
                      $t("pages_router_033")
                    }}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="signOut">{{ $t("pages_main_028") }}</a>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
          <!-- <div class="login-time">
            {{ $t("pages_main_057", [loginTime]) }}
          </div> -->
        </div>
      </div>
      <div
        id="menuContent"
        class="menu-content"
        :style="{ width: clientWidth < 800 ? '1280px' : 'auto' }"
      >
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  inject,
  onUnmounted,
  onMounted
} from 'vue'
import { useRouter } from 'vue-router'
import LeftMenu from './leftMenu/index'
import { _login } from '@/api/index'
import { getCountryLogo, parseMoney, localStorageClear } from '@/util'
import { useStore } from 'vuex'
import Cookies from 'js-cookie'
import LangSelector from '@/components/lang-sel'
export default defineComponent({
  name: 'MainPage',
  components: {
    'left-menu': LeftMenu,
    'language-selector': LangSelector
  },
  setup() {
    let timer = null
    const router = useRouter()
    const store = useStore()
    const state = reactive({
      themeData: inject('$themeData'),
      clientWidth: 0,
      loginTime: null,
      currentTime: new Date().getTime(),
      baseUrl: window.location.protocol + '//' + window.location.host
    })
    onMounted(() => {
      state.clientWidth = document.documentElement.clientWidth
    })
    onUnmounted(() => {
      window.onmousemove = null
      clearInterval(timer)
    })
    const init = async () => {
      loadMouseWatch()
      loadLoginTime()
      loadTimer()
      store.dispatch('getCurList')
      store.dispatch('getAreaList')
    }
    const signOut = async () => {
      await _login.loginOut()
      Cookies.remove('last_page_name')
      Cookies.remove('SESSION_ID')
      localStorageClear()
      router.replace('/login')
    }
    const loadTimer = () => {
      timer = setInterval(() => {
        loadIsExpired()
      }, 5000)
    }
    const loadIsExpired = () => {
      if (new Date().getTime() - state.currentTime > 5 * 1000 * 60) {
        clearInterval(timer)
        router.push('/user_leave')
      }
    }
    const loadMouseWatch = () => {
      window.onmousemove = () => {
        state.currentTime = new Date().getTime()
      }
    }
    const loadLoginTime = async () => {
      const res = await _login.queryLastLoginDate()
      if (res.data.succ) state.loginTime = res.data.data.lastLoginDate
    }

    init()
    return {
      getCountryLogo,
      parseMoney,
      signOut,
      init,
      ...toRefs(state)
    }
  }
})
</script>
<style lang="less" scoped>
#mainPage {
  display: flex;
  #rightMenu {
    width: 100%;
    background: #f8f9fb;
    height: 100vh;
    overflow-y: scroll;
    .menu-header {
      background: #fff;
      padding: 8px;
      white-space: nowrap;
      height: 56px;
      position: relative;
      border-bottom: 1px solid #e7e7e7;
      .merchant-name {
        font-size: 16px;
        font-weight: 600;
        color: #000;
        position: absolute;
        right: 28px;
        top: 8px;
        width: 400px;
        text-align: right;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .cur-list {
        height: 40px;
        display: flex;
        border-radius: 6px;
        margin-left: 24px;
        font-weight: 500;
        background: rgba(246, 246, 246, 1);
        padding-right: 20px;
        .cur {
          // padding: 0 36px;
          // margin: 0 6px;
          border-radius: 6px;
          // border-right: 1px solid #ECEFFC;
          text-align: left;
          position: relative;
          display: flex;
          margin-left: 20px;
          .ic-tip {
            color: @main-color;
            top: 2px;
            right: 2px;
            font-size: 15px;
            position: absolute;
          }
          .cur-name {
            font-size: 14px;
            img {
              width: 28px;
              height: 21px;
            }
            span {
              margin-left: 8px;
              margin-right: 8px;
            }
          }
          .amount_box{
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            line-height: 1.5;
            .available-amount{
              color:#74562C;
              font-size: 16px;
            }
            .wait-amount {
              color:#FF4D4F;
              font-size: 12px;
            }
          }
        }
        // .cur:first-child {
        //   padding-left: 0px;
        // }
        // .cur:last-child {
        //   border-right: 0;
        // }
      }
      .help-center {
        font-size: 13px;
        color: #1f223e;
        margin-top: 16px;
        cursor: pointer;
        img {
          width: 18px;
          margin: 0 5px 0 24px;
        }
      }
      .user-header {
        width: 30px;
        height: 30px;
        margin: 0px 0 0 24px;
      }
      .merchant-email {
        margin: 0px 24px 0 8px;
        font-size: 13px;
        text-align: center;
        color: #1f223e;
        position: relative;
      }
      .login-time {
        font-size: 11px;
        text-align: right;
      }
    }
    .menu-content {
      padding: 18px 50px;
      height: calc(100vh - 75px);
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }
}
</style>
